module.exports = __webpack_public_path__ + "img/public-announce.54364126.jpg";